var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2309)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_24_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.75C8.85652 14.75 10.637 14.0125 11.9497 12.6997C13.2625 11.387 14 9.60652 14 7.75C14 5.89348 13.2625 4.11301 11.9497 2.80025C10.637 1.4875 8.85652 0.75 7 0.75C5.14348 0.75 3.36301 1.4875 2.05025 2.80025C0.737498 4.11301 0 5.89348 0 7.75C0 9.60652 0.737498 11.387 2.05025 12.6997C3.36301 14.0125 5.14348 14.75 7 14.75ZM5.90625 9.9375H6.5625V8.1875H5.90625C5.54258 8.1875 5.25 7.89492 5.25 7.53125C5.25 7.16758 5.54258 6.875 5.90625 6.875H7.21875C7.58242 6.875 7.875 7.16758 7.875 7.53125V9.9375H8.09375C8.45742 9.9375 8.75 10.2301 8.75 10.5938C8.75 10.9574 8.45742 11.25 8.09375 11.25H5.90625C5.54258 11.25 5.25 10.9574 5.25 10.5938C5.25 10.2301 5.54258 9.9375 5.90625 9.9375ZM7 4.25C7.23206 4.25 7.45462 4.34219 7.61872 4.50628C7.78281 4.67038 7.875 4.89294 7.875 5.125C7.875 5.35706 7.78281 5.57962 7.61872 5.74372C7.45462 5.90781 7.23206 6 7 6C6.76794 6 6.54538 5.90781 6.38128 5.74372C6.21719 5.57962 6.125 5.35706 6.125 5.125C6.125 4.89294 6.21719 4.67038 6.38128 4.50628C6.54538 4.34219 6.76794 4.25 7 4.25Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_24_2309"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75H14V14.75H0V0.75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information_icon.c7a5b769211393f0273608220d056b89.svg";
export { ForwardRef as ReactComponent };